import { render, staticRenderFns } from "./aiCase.vue?vue&type=template&id=214de0b6&scoped=true"
import script from "./aiCase.vue?vue&type=script&lang=js"
export * from "./aiCase.vue?vue&type=script&lang=js"
import style0 from "./aiCase.vue?vue&type=style&index=0&id=214de0b6&prod&lang=scss&scoped=true"
import style1 from "./aiCase.vue?vue&type=style&index=1&id=214de0b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214de0b6",
  null
  
)

export default component.exports